export const TOKEN_NAME = 'thegioithuoc-auth$token';

export const IMPERSONATE_TOKEN_NAME = 'thegioithuoc-impersonate$token';

export const token = {
  get: () => {
    const session = localStorage.getItem(TOKEN_NAME);
    return session ? JSON.parse(session) : null;
  },
  set: (value?: string | null) => {
    if (value) {
      localStorage.setItem(TOKEN_NAME, value);
    } else {
      localStorage.removeItem(TOKEN_NAME);
    }
  }
};

export const impersonateToken = {
  get: () => {
    const session = localStorage.getItem(IMPERSONATE_TOKEN_NAME);
    return session ? JSON.parse(session) : null;
  },
  set: (value?: string | null) => {
    if (value) {
      localStorage.setItem(IMPERSONATE_TOKEN_NAME, value);
    } else {
      localStorage.removeItem(IMPERSONATE_TOKEN_NAME);
    }
  }
};
